"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LocationIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M10.06 13.392C12.236 10.713 14 8.542 14 6A6 6 0 002 6c0 2.541 1.764 4.713 3.94 7.392C6.6 14.206 7.3 15.067 8 16a85.26 85.26 0 012.06-2.608zM8 9a3 3 0 100-6 3 3 0 000 6z",
    clipRule: "evenodd"
  })))
});
LocationIcon.displayName = 'LocationIcon';
var _default = exports.default = LocationIcon;